import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { getPercentage } from 'core/utils';
import { PricingProfilePartNumberType } from 'pricing/enums';
import { PricingHelper } from 'pricing/helpers';

import { ActionsCell } from './cells';

interface IColumnDefParams {
  isEditable?: boolean;
}

export const getColumnDef = ({ isEditable = true }: IColumnDefParams = {}): ColDef[] => [
  {
    colId: 'actions',
    width: 80,
    maxWidth: 80,
    sortable: false,
    resizable: false,
    cellRenderer: ActionsCell,
    cellRendererParams: { isEditable },
    suppressColumnsToolPanel: true,
    pinned: 'left',
    lockPinned: true,
  },
  {
    colId: 'part',
    headerName: t('headerPartNumber'),
    field: 'part',
    filter: 'agTextColumnFilter',
    width: 250,
  },
  {
    colId: 'manufacturerName',
    headerName: t('headerManufacturer'),
    field: 'manufacturerName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'description',
    headerName: t('headerDescription'),
    field: 'description',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'uom',
    headerName: t('headerUom'),
    field: 'uom',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'pricingType',
    headerName: t('headerPricingType'),
    field: 'pricingType',
    valueGetter: ({ data }) => (data?.margin ? t('labelMargin') : t('labelFixed')),
    filter: 'agSetColumnFilter',
    filterParams: {
      valueFormatter: ({ value }) =>
        value === PricingProfilePartNumberType.MARGIN ? t('labelMargin') : t('labelFixed'),
      values: [PricingProfilePartNumberType.MARGIN, PricingProfilePartNumberType.PRICE],
      defaultToNothingSelected: true,
    },
    sortable: false,
  },
  {
    colId: 'listPrice',
    headerName: t('headerListPrice'),
    field: 'price',
    valueGetter: ({ data }) => data?.pricing?.[data?.uom]?.listPrice,
    valueFormatter: ({ value }) => PricingHelper.formatPricing({ amount: value }),
    sortable: false,
  },
  {
    colId: 'purchasedCost',
    headerName: t('headerSpecialCost'),
    field: 'purchasedCost',
    filter: 'agNumberColumnFilter',
    valueFormatter: ({ value }) => PricingHelper.formatPricing({ amount: value }),
  },
  {
    colId: 'cost',
    headerName: t('headerSpecialStdCost'),
    field: 'cost',
    filter: 'agNumberColumnFilter',
    valueFormatter: ({ value }) => PricingHelper.formatPricing({ amount: value }),
  },
  {
    colId: 'price',
    headerName: t('headerFixedPrice'),
    field: 'price',
    filter: 'agNumberColumnFilter',
    valueFormatter: ({ value }) => PricingHelper.formatPricing({ amount: value }),
  },
  {
    colId: 'margin',
    headerName: t('headerMargin'),
    field: 'margin',
    filter: 'agNumberColumnFilter',
    filterParams: {
      numberParser: (value) => value / 100,
      numberFormatter: (value) => value * 100,
    },
    valueFormatter: ({ data }) => getPercentage(data?.margin),
  },
];
